import '../../scripts/domPolyfills/closest';
import { validateEmail } from '../../scripts/utils/validateEmail';
import {
  REGEXP_SPECIAL_SYMBOLS,
  WEBINAR_ACTIONS,
  WEBINAR_EVENT_CATEGORY,
} from '../../scripts/config/constants';
import { sendWebinarsEvent } from '../../scripts/config/analytics';

const validateText = (text) => !REGEXP_SPECIAL_SYMBOLS.test(String(text));

const ERROR_TYPES = {
  required: 'This field is required.',
  specialSymbols: 'Use only letters and numbers.',
  emailFormat: 'Please enter a valid email address.',
};

const formClassShowResult = 'webinar-individual-form--show-result';
const formControlSelector = '[data-control-validate]';
const formControlErrorSelector = '[data-control-error]';

export function initWebinarIndividualForm(formIndividualDataId) {
  const formEl = document.querySelector(
    `[data-webinar-individual-form='${formIndividualDataId}']`
  );

  formEl.setAttribute('novalidate', 'true');

  formEl.addEventListener('submit', (event) => {
    event.preventDefault();

    const isValid = validateForm(formEl);

    if (isValid) {
      setBotTrapValue(formEl);

      const formData = getFormData(formEl);

      clearControlsErrors(formEl);
      sendRequest(formEl, formData);
    }
  });

  function sendRequest(form, data) {
    const options = {
      method: 'POST',
      body: JSON.stringify(data),
    };

    fetch(`${form.dataset.submitUrl}`, options)
      .then((response) => {
        if (response.status !== 200) {
          showResult(form, false);
          return Promise.reject(new Error(response.statusText));
        }
        return Promise.resolve(response);
      })
      .then(() => {
        showResult(form, true);
        sendFormSuccessAnalytics(form);
      })
      .catch((err) => {
        showResult(form, false);
        console.warn(
          'Error when sending the registration form to the webinar',
          err
        );
      });
  }

  function showResult(form, isSuccess = true) {
    const resultElm = form.querySelector(`[data-success][data-error]`);

    if (resultElm) {
      resultElm.innerHTML = isSuccess
        ? resultElm.getAttribute('data-success')
        : resultElm.getAttribute('data-error');
    }

    form.classList.add(formClassShowResult);
  }
}

function validateForm(form) {
  let isValid = true;

  const formInputs = form ? form.querySelectorAll('input') : [];

  formInputs.forEach((input) => {
    if (isValid && input.name !== 'trap') {
      const invalidMessage = mkValidateMessage(input.value, input.type);

      if (invalidMessage) {
        isValid = false;

        setControlError(input.closest(formControlSelector), invalidMessage);
      } else {
        clearControlError(input.closest(formControlSelector));
      }
    }
  });

  return isValid;
}

function getFormData(form) {
  const inputs = form.querySelectorAll('input');
  const formData = {};

  inputs.forEach((input) => {
    formData[input.name] = input.value;
  });

  return formData;
}

function setBotTrapValue(form) {
  const inputTrap = form.querySelector('[name="trap"]');

  if (inputTrap && inputTrap.value === '') {
    inputTrap.value = 'not_a_bot';
  }
}

function mkValidateMessage(value, type) {
  if (!value.trim()) {
    return ERROR_TYPES.required;
  }

  if (type === 'text' && !validateText(value)) {
    return ERROR_TYPES.specialSymbols;
  }

  if (type === 'email' && !validateEmail(value)) {
    return ERROR_TYPES.emailFormat;
  }

  return null;
}

function setControlError(control, errorText = '') {
  if (control) {
    control.setAttribute('data-error', Boolean(errorText));

    const errorEl = control.querySelector(formControlErrorSelector);

    if (errorEl) {
      errorEl.innerHTML = errorText;
    }
  }
}

function clearControlError(control) {
  return setControlError(control, '');
}

function clearControlsErrors(form) {
  form.querySelectorAll(formControlSelector).forEach((control) => {
    clearControlError(control);
  });
}

function sendFormSuccessAnalytics(form) {
  const webinarId = form.getAttribute('data-webinar-individual-form');
  const isRecordedEvent = form.getAttribute('data-passed-event') === 'true';

  if (webinarId) {
    const categoryEvent = isRecordedEvent
      ? WEBINAR_EVENT_CATEGORY.RECORD
      : WEBINAR_EVENT_CATEGORY.LIVE;

    sendWebinarsEvent(
      categoryEvent,
      WEBINAR_ACTIONS.END_REGISTRATION,
      webinarId
    );
  }
}
